import './MessageCloud.scss';

import React, { useMemo } from 'react'
import { ChatMessage } from '../../models/LLM'
import classNames from 'classnames';
import Markdown from 'react-markdown';

type Props = {
  message?: ChatMessage;
  children?: React.ReactNode;
}

export default function MessageCloud({ message, children }: Props) {
  const messageContent = useMemo(() => children || message?.text || "Message", [message, children]);

  return (
    <div className={classNames("message-cloud", { user: message?.isUserPrompt })}>
      {typeof messageContent === 'object'
        ? messageContent
        : <Markdown>{messageContent}</Markdown>
      }
    </div>
  )
}